import { useEffect } from 'react';

/**
 * 将播放器实际高度写入 CSS 变量 --tenryu-player-h
 * 供视频浮窗 bottom 对齐、以及页面留白等用途。
 */
export function usePlayerHeightCssVar({ playerRef, isFullscreen }) {
  useEffect(() => {
    const el = playerRef?.current;
    if (!el) return;

    let rafId = 0;
    let lastH = -1;

    const writeHeightNow = () => {
      try {
        const h = isFullscreen ? 0 : Math.ceil(el.getBoundingClientRect().height || 0);
        if (h === lastH) return;
        lastH = h;
        document.documentElement.style.setProperty('--tenryu-player-h', `${h}px`);
      } catch (_) {}
    };

    const scheduleWriteHeight = () => {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        writeHeightNow();
      });
    };

    scheduleWriteHeight();

    if (typeof ResizeObserver !== 'undefined') {
      const ro = new ResizeObserver(() => scheduleWriteHeight());
      try { ro.observe(el); } catch (_) {}
      return () => {
        if (rafId) cancelAnimationFrame(rafId);
        try { ro.disconnect(); } catch (_) {}
      };
    }

    window.addEventListener('resize', scheduleWriteHeight);
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      window.removeEventListener('resize', scheduleWriteHeight);
    };
  }, [playerRef, isFullscreen]);
}

